import {propsType} from "./Cashpick2";
import React from "react";
import AccessDeniedPage from "../common/AccessDeniedPage";

export default function NshopQuiz(props: propsType) {
    return (
        <AccessDeniedPage />
    );

}